import { Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import acceptInviteIcon from 'assets/images/profilepage-invite-accept.svg'
import { useAtom } from 'jotai'
import { localeAtom } from 'config/store'
import i18n from 'i18n'
import { getLanguage } from 'utils/localStorage'
import { useEffect, useState } from 'react'
import iconVi from 'assets/images/Vietnam.svg.png'
import iconLA from 'assets/images/Lao.svg.png'
import iconEN from 'assets/images/eng.png'
import { useUpdateSetting } from 'dataLayer/user'
function Setting() {
	const { t } = useTranslation()
	const i18nextLng = getLanguage()

	const [locale, setLocale] = useAtom(localeAtom)
	const [language, setLanguage] = useState('')
	const [backgroundMusic, setBackgroundMusic] = useState(false)
	useEffect(() => {
		setLanguage(i18nextLng)
	}, [])
	const { mutate } = useUpdateSetting(() => { })
	const handleChangeMusic = e => {
		setBackgroundMusic(e.target.checked)
		mutate({
			background_music: e.target.checked ? 1 : 0,
		})
	}
	const changeLanguage = lng => {
		i18n.changeLanguage(lng)
		mutate({
			language: lng,
		})
	}
	return (
		<>
			<Row className="profilepage-content__title">
				{t('profile.setting.sounds')}
			</Row>
			<Row className="profilepage-content__body setting mt-3">
				<Row className="content sound">
					<p>{t('profile.setting.bg_music')}</p>
					<Form>
						<Form.Check
							defaultChecked={backgroundMusic}
							onChange={handleChangeMusic}
							type="switch"
						/>
					</Form>
				</Row>
				{/* <Row className="content">
					<p>{t('profile.setting.bg_music')}</p>
					<Form>
						<Form.Check type="switch" />
					</Form>
				</Row> */}
			</Row>
			<Row className="profilepage-content__title mt-4">
				{t('profile.setting.lang')}
			</Row>
			<Row className="profilepage-content__body setting my-3">
				<Row
					className="content"
					onClick={() => {
						changeLanguage('en')
						setLocale('en')
						setLanguage('en')
					}}
				>
					<div style={{ width: '50%', display: 'inherit' }}>
						<img
							style={{ width: 24, height: 20, marginRight: 20 }}
							src={iconEN}
							alt="en"
						/>
						<p>{t('profile.setting.en')}</p>
					</div>

					{language === 'en' ? (
						<img src={acceptInviteIcon} alt="English" />
					) : null}
				</Row>
				<Row
					className="content"
					onClick={() => {
						changeLanguage('la')
						setLocale('la')
						setLanguage('la')
					}}
				>
					<div style={{ width: '50%', display: 'inherit' }}>
						<img
							style={{ width: 24, height: 20, marginRight: 20 }}
							src={iconLA}
							alt="la"
						/>
						<p>{t('profile.setting.la')}</p>
					</div>
					{language === 'la' ? (
						<img src={acceptInviteIcon} alt="Laotian" />
					) : null}
				</Row>
				<Row
					className="content"
					onClick={() => {
						changeLanguage('vi')
						setLocale('vi')
						setLanguage('vi')
					}}
				>
					<div style={{ width: '50%', display: 'inherit' }}>
						<img
							style={{ width: 24, height: 20, marginRight: 20 }}
							src={iconVi}
							alt="en"
						/>
						<p>{t('profile.setting.vi')}</p>
					</div>

					{language === 'vi' ? (
						<img src={acceptInviteIcon} alt="VietNamese" />
					) : null}
				</Row>
			</Row>
		</>
	)
}

export default Setting
